module.exports = __webpack_public_path__ + "static/media/Certificado Ativo.03eaa8ce.svg";